var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivedistrict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(26 549)",
    fill: "#111a45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_96",
    "data-name": "Mask Group 96",
    transform: "translate(-26 -549)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01-home",
    "data-name": "01-home",
    transform: "translate(30.983 551.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M11.113.206A8.027,8.027,0,0,0,3.1,8.224c0,2.148,1.3,4.905,3.867,8.2a43.6,43.6,0,0,0,3.811,4.266.491.491,0,0,0,.679,0,43.6,43.6,0,0,0,3.811-4.266c2.566-3.291,3.867-6.049,3.867-8.2A8.027,8.027,0,0,0,11.113.206Zm0,13.744a5.727,5.727,0,1,1,5.727-5.727A5.733,5.733,0,0,1,11.113,13.95Z",
    transform: "translate(-3.095 -0.206)",
    fill: "#111a45"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "D",
    transform: "translate(39 563)",
    fill: "#111a45",
    fontSize: 9,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "D")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivedistrict);
export default __webpack_public_path__ + "static/media/inactivedistrict.39d847e8cf213dfad147338c3e99ae2d.svg";
export { ForwardRef as ReactComponent };